import { type FC } from 'react'
import classNames from 'classnames'
import { Button, type IButtonProps } from 'shared/ui'
import styles from './styles.module.scss'

type IAiCheckerNextButtonProps = Omit<IButtonProps, 'fullWidth'> & {
  isSuccess?: boolean
  isError?: boolean
  isContinueWithIssues?: boolean
  onContinueWithIssuesClick?: () => void
  isContinueWithIssuesLoading?: boolean
  isSubmitLoading?: boolean
  continueWithIssuesText?: string
}

export const AiCheckerNextButtons: FC<IAiCheckerNextButtonProps> = (props) => {
  const {
    loading,
    isSuccess,
    isError,
    text,
    icon,
    isContinueWithIssues,
    onContinueWithIssuesClick,
    isContinueWithIssuesLoading,
    isSubmitLoading,
    continueWithIssuesText,
    disabled,
    ...rest
  } = props
  if (loading) {
    return (
      <div className={styles.wrap}>
        <Button
          fullWidth
          size='medium'
          className={classNames(styles.btn, styles.loading)}
          icon={icon}
          {...rest}
          text='Checking for issues...'
          disabled={disabled}
        />
      </div>
    )
  }

  const btnText = isError ? 'Some issues found' : isSuccess ? '' : text
  const btnIcon = isSuccess ? 'check2Correct' : isError ? 'alertTriangle' : icon

  return (
    <div className={styles.wrap}>
      <Button
        {...rest}
        fullWidth
        className={classNames(styles.btn, {
          [styles.success]: isSuccess,
          [styles.error]: isError,
        })}
        text={btnText}
        icon={btnIcon}
        loading={isSubmitLoading}
        disabled={isContinueWithIssuesLoading || disabled}
      />
      {isContinueWithIssues && (
        <Button
          {...rest}
          fullWidth
          text={continueWithIssuesText || 'Continue anyway'}
          icon={'alertTriangle'}
          typeBtn='contained'
          contained='secondary'
          style={{ height: 40 }}
          onClick={onContinueWithIssuesClick}
          loading={isContinueWithIssuesLoading}
          disabled={disabled}
        />
      )}
    </div>
  )
}
